<div class="dp-zoom">
    <span class="content">
        <span class="zoom-btn iconfont icon-srt-minus" data-action="zoomIn" title="缩小"></span>
        <span class="zoom-text" data-action="zoomText">{{percentage}}</span>
        <span class="zoom-btn iconfont icon-srt-plus" data-action="zoomOut" title="放大"></span>
    </span>
</div>